import { render } from "./AdditionalNotes.vue?vue&type=template&id=ca02d1b2"
import script from "./AdditionalNotes.vue?vue&type=script&lang=js"
export * from "./AdditionalNotes.vue?vue&type=script&lang=js"

import "./AdditionalNotes.vue?vue&type=style&index=0&id=ca02d1b2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/AdditionalNotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca02d1b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca02d1b2', __exports__)) {
    console.log('reload')
    api.reload('ca02d1b2', __exports__)
  }
  
  module.hot.accept("./AdditionalNotes.vue?vue&type=template&id=ca02d1b2", () => {
    console.log('re-render')
    api.rerender('ca02d1b2', render)
  })

}


export default __exports__